//https://www.npmjs.com/package/smooth-scroll

import SmoothScroll from "smooth-scroll";

new SmoothScroll('a[href*="#"]', {
  ignore: "[data-vc-container]"
});
